// extracted by mini-css-extract-plugin
export default {"wrap":"oG-z","articleImagesWrap":"pG-z","articleImage":"qG-z","singleImage":"rG-z"};